// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__17Al4","hideScroll":"Table_hideScroll__36Ljt","negative":"Table_negative__wEx7x","totalString":"Table_totalString__2Lamt"};